import { ColumnMetadata, DataGridRow, RowSizes } from "~/components/DataGrid";
import { AssetTableRowData } from "./types";
import { useCallback, useState } from "react";
import { Asset, AssetColumns } from "~/modules/assets/types";
import { AdditionalNetworksRow } from "./AdditionalNetworksRow";
import * as Analytics from "../../analytics";

// // // //

export function AssetTableRow(props: {
    asset: Asset;
    columns: ColumnMetadata<AssetTableRowData, AssetColumns>[];
    rowIndex: number;
    size: RowSizes;
    scrollLeft: number;
    defaultExpandedState: boolean;
    bordered?: boolean;
    striped?: boolean;
    includeAdditionalNetworksRow?: boolean;
}) {
    const {
        asset,
        columns,
        rowIndex,
        size,
        scrollLeft,
        defaultExpandedState,
        bordered,
        striped,
        includeAdditionalNetworksRow = true,
    } = props;
    const [expanded, setExpanded] = useState(defaultExpandedState);

    function onExpandOrig() {
        const updatedState = !expanded;

        // Track change in analytics
        if (updatedState) {
            Analytics.trackExpandTableRow({
                assetName: asset.name,
            });
        } else {
            Analytics.trackCollapseTableRow({
                assetName: asset.name,
            });
        }
        setExpanded(updatedState);
    }

    // NOTE - we define this function with useCallback to prevent redundant re-renders
    const onExpand = useCallback(() => {
        onExpandOrig();
    }, [expanded]);

    return (
        <>
            <DataGridRow<AssetTableRowData, AssetColumns>
                row={{
                    ...asset,
                    expanded,
                    isAsset: true,
                    rowIndex,
                    onExpand,
                }}
                key={asset.id}
                columns={columns}
                size={size}
                bordered={bordered}
                scrollLeft={scrollLeft}
                striped={striped && rowIndex % 2 === 1}
            />
            {expanded && (
                <>
                    {asset.tokens.map((tkn) => (
                        <DataGridRow<AssetTableRowData, AssetColumns>
                            row={{
                                ...tkn,
                                expanded: false,
                                isAsset: false,
                                parentAsset: asset,
                            }}
                            key={tkn.id}
                            columns={columns}
                            size={size}
                            bordered={bordered}
                            scrollLeft={scrollLeft}
                            striped={rowIndex % 2 === 1}
                        />
                    ))}
                    {includeAdditionalNetworksRow && (
                        <AdditionalNetworksRow size={size} />
                    )}
                </>
            )}
        </>
    );
}
